import { useACL } from '@/useACL';
const { can } = useACL();

export default {
    inserted(el, binding) {
        const [action, resource, attrs] = binding.value || [];
        if (!can(action, resource, attrs || {})) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    },
    update(el, binding) {
        // opzionale: riesegui al cambio binding
        const [action, resource, attrs] = binding.value || [];
        const visible = can(action, resource, attrs || {});
        el.style.display = visible ? '' : 'none';
    }
};
